import {
  BpkBox,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkProgress from '@skyscanner-internal/backpack-web/bpk-component-progress';
import BpkRating, {
  RATING_SIZES,
  RATING_SCALES,
} from '@skyscanner-internal/backpack-web/bpk-component-rating';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import BpkThemeProvider from '@skyscanner-internal/backpack-web/bpk-theming';

import { marcommsDarkSky } from '@skyscanner/bpk-foundations-web/tokens/base.es6';

const MAX_VALUE = 5;
const MIN_VALUE = 0;

export default ({
  ariaLabel,
  label,
  rating,
}: {
  rating: number;
  label: string;
  ariaLabel: string;
}) => (
  <BpkBox
    display="flex"
    flexDirection="column"
    marginBottom={BpkSpacing.MD}
    data-testid="rating"
  >
    <BpkBox
      display="flex"
      flexDirection="row"
      alignItems="center"
      marginBottom={BpkSpacing.MD}
    >
      <BpkText tagName="span" textStyle={TEXT_STYLES.footnote}>
        {label}
      </BpkText>
      <BpkBox flex="1" />
      <BpkBox>
        {rating > 1 && (
          <BpkRating
            ariaLabel=""
            title=""
            ratingScale={RATING_SCALES.zeroToFive}
            size={RATING_SIZES.base}
            value={rating.toFixed(1)}
          />
        )}
      </BpkBox>
    </BpkBox>
    <BpkBox width="100%" tabIndex={-1}>
      <BpkThemeProvider
        theme={{ progressBarFillColor: marcommsDarkSky }}
        themeAttributes={['progressBarFillColor']}
      >
        <BpkProgress
          min={MIN_VALUE}
          max={MAX_VALUE}
          small
          value={rating > 1 ? rating : 0}
          aria-label={ariaLabel}
          tabIndex={-1}
        />
      </BpkThemeProvider>
    </BpkBox>
  </BpkBox>
);
